import React, { useCallback } from 'react';
import { connect } from "react-redux";

import { tableColumn } from "utils";
import { TableList, ActionButton } from 'components/common';
import CityValue from "../CityValue";


const CityList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, city }) => {
  const defaultColumnList = ['id', 'name', 'slug', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    name: tableColumn('Название', 'name', {
      render: (val, item) => <CityValue detail={item} asLink={true} isBack={true}/>,
      sorter: true,
    }),
    slug: tableColumn('Путь', 'slug', {
      sorter: true,
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton
          detail={item}
          modelActions={actions.city}
          actions={[{ name: 'edit' }, { name: 'delete' }]}
        />
      ),
    }),
  };

  const onLoad = useCallback(({ query, activeFilter }) => {
    if (activeFilter === undefined) {
      activeFilter = city.filter.activeFilter
    }
    actions.city.listLoad({ query, activeFilter, locationChange: true });
  }, [city, actions]);

  return (
    <TableList
      location={router.location}
      model={city}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}
    />
  );
};

const mapState = state => ({
  router: state.router,
  city: state.city,
});

const mapDispatch = dispatch => ({
  actions: {
    city: dispatch.city,
  }
});

export default connect(mapState, mapDispatch)(CityList);
